import PropTypes from 'prop-types';
import React, { Component } from 'react';
import HtmlClassName from './HtmlClassName';

const defaultProps = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]),
};

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({
        open: nextProps.open,
      });
    }
  }

  handleOutsideClick() {
    if (this.props.block === false) {
      this.setState({
        open: false,
      }, () => {
        this.props.onClose();
      });
    }
  }

  handleCloseTap() {
    this.setState({
      open: false,
    }, () => {
      this.props.onClose();
    });
  }

  render() {
    const {
      open,
    } = this.state;
    const {
      children,
      className,
      dialogClassName,
      lightbox,
    } = this.props;
    let closeButton = null;
    let htmlClassName = '';
    const modalStyle = {};
    const modalClassNames = ['uk-modal'];
    const modalDialogClassNames = ['uk-modal-dialog'];
    const modalDialogStyle = {}; // @TODO calculate and set the `top` attribute

    if (open === true) {
      modalClassNames.push('uk-open');
      htmlClassName = 'uk-modal-page';
      modalStyle.display = 'block';
    }

    if (className) {
      modalClassNames.push(className);
    }

    if (dialogClassName) {
      modalDialogClassNames.push(dialogClassName);
    }

    if (lightbox === true) {
      modalDialogClassNames.push('uk-modal-dialog-lightbox');
      closeButton = (
        <button
          type="button"
          className="uk-modal-close uk-close uk-close-alt"
          onClick={() => this.handleCloseTap()}
        />
      );
    }

    return (
      <HtmlClassName className={htmlClassName}>
        <div className={modalClassNames.join(' ')} style={modalStyle} onClick={(evt) => { evt.preventDefault(); evt.stopPropagation(); this.handleOutsideClick(); }}>
          <div className={modalDialogClassNames.join(' ')} style={modalDialogStyle} onClick={(evt) => { evt.preventDefault(); evt.stopPropagation(); }}>
            {closeButton}
            {children}
          </div>
        </div>
      </HtmlClassName>
    );
  }
}

Modal.ModalHeader = props => (
  <div className="uk-modal-header">
    {props.children}
  </div>
);

Modal.ModalHeaderTitle = props => (
  <h3 className="uk-modal-title">
    {props.children}
  </h3>
);

Modal.ModalContent = props => (
  <div className="uk-margin uk-modal-content">
    {props.children}
  </div>
);

Modal.ModalFooter = props => (
  <div className="uk-modal-footer uk-text-right">
    {props.children}
  </div>
);

Modal.ModalImage = props => (
  <img src={props.src} alt={props.alt} className={[props.className || '', 'dense-image dense-ready'].join(' ')} />
);

Modal.ModalCaption = props => (
  <div className="uk-modal-caption">
    {props.children}
  </div>
);

Modal.propTypes = Object.assign({}, defaultProps, {
  open: PropTypes.bool,
  block: PropTypes.bool,
  lightbox: PropTypes.bool,
  onClose: PropTypes.func,
  dialogClassName: PropTypes.string,
});
Modal.ModalHeader.propTypes = Object.assign({}, defaultProps);
Modal.ModalHeaderTitle.propTypes = Object.assign({}, defaultProps);
Modal.ModalContent.propTypes = Object.assign({}, defaultProps);
Modal.ModalFooter.propTypes = Object.assign({}, defaultProps);
Modal.ModalCaption.propTypes = Object.assign({}, defaultProps);
Modal.ModalImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

Modal.defaultProps = {
  open: false,
  onClose: () => {},
  dialogClassName: '',
  block: false,
  lightbox: false,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js